<template>
  <div class="notice-setting">
    <!-- <van-nav-bar @click-left="clickBack" left-arrow /> -->

    <van-cell-group title="老师消息权限" :border="false" v-if="teacher">
      <!-- 家长 -->
      <van-cell center title="接收访客进出信息">
        <template #right-icon>
          <van-switch
            v-model="visitorEnterSchool"
            size="25"
            active-color="rgb(4, 190, 2)"
            @change="updateStatus(2)"
          />
        </template>
      </van-cell>
      <van-cell center title="接收考勤打卡信息">
        <template #right-icon>
          <van-switch
            v-model="teacherEnterSchool"
            size="25"
            active-color="rgb(4, 190, 2)"
            @change="updateStatus(3)"
          />
        </template>
      </van-cell>
      <!-- 老师 -->
    </van-cell-group>
    <van-cell-group title="家长消息权限" :border="false" v-if="student">
      <van-cell center title="接收孩子考勤打卡信息">
        <template #right-icon>
          <van-switch
            v-model="studentEnterSchool"
            size="25"
            active-color="rgb(4, 190, 2)"
            @change="updateStatus(0)"
          />
        </template>
      </van-cell>
      <van-cell center title="接收家长进出校园消息">
        <template #right-icon>
          <van-switch
            v-model="parentEnterSchool"
            size="25"
            active-color="rgb(4, 190, 2)"
            @change="updateStatus(1)"
          />
        </template>
      </van-cell>
    </van-cell-group>
    <!--预警通知-->
    <van-cell-group title="预警消息权限" :border="false" v-if="teacher">
      <!-- <van-cell center title="接收陌生人预警信息">
        <template #right-icon>
          <van-switch
            v-model="strangerEnterSchool"
            size="25"
            active-color="rgb(4, 190, 2)"
            @change="updateStatus(7)"
          />
        </template>
      </van-cell> -->
      <van-cell center title="接收预/报警消息">
        <template #right-icon>
          <van-switch
            v-model="BlackEnterSchool"
            size="25"
            active-color="rgb(4, 190, 2)"
            @change="updateStatus(8)"
          />
        </template>
      </van-cell>
    </van-cell-group>
    <div class="hint">备注：开启通知将会收到微信通知提醒</div>
  </div>
</template>

<script>
export default {
  name: "notice-setting",
  data() {
    return {
      studentEnterSchool: false,
      studentEnterSchoolId: undefined,
      parentEnterSchool: false,
      parentEnterSchoolId: undefined,
      visitorEnterSchool: false, //接收访客
      visitorEnterSchoolId: undefined,
      teacherEnterSchool: false, //接收考勤
      teacherEnterSchoolId: undefined,
      strangerEnterSchool: false,
      strangerEnterSchoolId: undefined,//陌生人通知
      BlackEnterSchool: false,
      BlackEnterSchoolId: undefined,//黑名单通知
    };
  },
  created() {
    if (this.$store.state.puserId) {
      this.getNoticeTypeList({
        type: "student",
        id: this.$store.state.puserId,
      });
    }
    if (this.$store.state.userId) {
      this.getNoticeTypeList({
        type: "teacher",
        id: this.$store.state.userId,
      });
    }
  },
  computed: {
    getPersonType() {
      return (
        localStorage.getItem("userInfo") &&
        JSON.parse(localStorage.getItem("userInfo")).personType
      );
    },
    getInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
    student() {
      if (this.getInfo.patriarchSchoolId && this.getInfo.patriarchUserId) {
        return true;
      }
      return false;
    },
    teacher() {
      if (this.getInfo.id && this.getInfo.schoolId) {
        return true;
      }
      return false;
    },
  },
  methods: {
    // clickBack() {
    //   this.$router.go(-1)
    // },
    close() {
      WeixinJSBridge.call("closeWindow");
    },
    getNoticeTypeList(params) {
      this.axios
        .get(
          `student-consumer/api/subscribeInfo/getSubscribeInfoStatusList?userId=${params.id}`
        )
        .then((res) => {
          if (res.code === 200) {
            res.data &&
              res.data.forEach((item) => {
                if (params.type == "student") {
                  if (item.type == 0) {
                    this.studentEnterSchool = true;
                    this.studentEnterSchoolId = item.id;
                  } else if (item.type == 1) {
                    this.parentEnterSchool = true;
                    this.parentEnterSchoolId = item.id;
                  }
                }
                if (params.type == "teacher") {
                  if (item.type == 2) {
                    this.visitorEnterSchool = true;
                    this.visitorEnterSchoolId = item.id;
                  } else if (item.type == 3) {
                    this.teacherEnterSchool = true;
                    this.teacherEnterSchoolId = item.id;
                  } else if(item.type==7){
                    this.strangerEnterSchool = true;
                    this.strangerEnterSchoolId = item.id;
                 } else if(item.type==8){
                    this.BlackEnterSchool = true;
                    this.BlackEnterSchoolId = item.id;
                 }
                }
              });
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openNoticeState(params) {
      this.axios
        .post(`student-consumer/api/subscribeInfo/saveSubScribeInfoStatus`, {
          type: params.type,
          userId: params.id,
        })
        .then((res) => {
          if (res.code === 200 && res.data) {
            if (res.data.type == 0) {
              this.studentEnterSchoolId = res.data.id;
            } else if (res.data.type == 1) {
              this.parentEnterSchoolId = res.data.id;
            } else if (res.data.type == 2) {
              this.visitorEnterSchoolId = res.data.id;
            } else if (res.data.type == 3) {
              this.teacherEnterSchoolId = res.data.id;
            } else if (res.data.type == 7) {
              this.strangerEnterSchoolId = res.data.id;
            } else if (res.data.type == 8) {
              this.BlackEnterSchoolId = res.data.id;
            }
            console.log("保存成功");
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeNoticeState(type) {
      console.log(type);

      this.axios
        .post(`student-consumer/api/subscribeInfo/deleteSubscribeInfo`, [type])
        .then((res) => {
          if (res.code === 200) {
            console.log("保存成功");
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateStatus(type) {
      console.log(type);
      if (type == 0) {
        if (!this.studentEnterSchool) {
          this.closeNoticeState(this.studentEnterSchoolId);
        } else {
          this.openNoticeState({
            type: 0,
            id: this.$store.state.puserId,
          });
        }
      } else if (type == 1) {
        if (!this.parentEnterSchool) {
          this.closeNoticeState(this.parentEnterSchoolId);
        } else {
          this.openNoticeState({
            type: 1,
            id: this.$store.state.puserId,
          });
        }
      } else if (type == 2) {
        if (!this.visitorEnterSchool) {
          this.closeNoticeState(this.visitorEnterSchoolId);
        } else {
          this.openNoticeState({
            type: 2,
            id: this.$store.state.userId,
          });
          // this.openNoticeState(2)
        }
      } else if (type == 3) {
        if (!this.teacherEnterSchool) {
          this.closeNoticeState(this.teacherEnterSchoolId);
        } else {
          this.openNoticeState({
            type: 3,
            id: this.$store.state.userId,
          });
          // this.openNoticeState(3)
        }
      } else if (type == 7) {
        if (!this.strangerEnterSchool) {
          this.closeNoticeState(this.strangerEnterSchoolId);
        } else {
          if (this.$store.state.userId){
            this.openNoticeState({
              type: 7,
              id: this.$store.state.userId,
            });
          }
        }
      } else if (type == 8) {
        if (!this.BlackEnterSchool) {
          this.closeNoticeState(this.BlackEnterSchoolId);
        } else {
          if (this.$store.state.userId){
            this.openNoticeState({
              type: 8,
              id: this.$store.state.userId,
            });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::deep .van-cell-group {
  margin: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  overflow: hidden;
}
.hint {
  color: #969799;
  font-size: 0.75rem;
  margin: 1rem;
  text-align: right;
}
</style>
